import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The old mock registration page has been removed. `/register` now forwards to
 * the single genuine authentication flow at `/auth`.
 */
export const Route = createFileRoute("/register")({
  beforeLoad: () => {
    throw redirect({ to: "/auth", search: { redirect: "/portal" } });
  },
});
